import { render, staticRenderFns } from "./LockAccount.vue?vue&type=template&id=7e978180&"
import script from "./LockAccount.vue?vue&type=script&lang=js&"
export * from "./LockAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports